// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\GoogleCalendarListResponse

import { hydrateGoogleCalendarListItem, type GoogleCalendarListItem, type GoogleCalendarListItemApiResponse } from './googleCalendarListItem.gen';

export type GoogleCalendarListApiResponse = {
	items: GoogleCalendarListItemApiResponse[] | null;
};

export type GoogleCalendarList = {
	items: GoogleCalendarListItem[] | null;
};

export function hydrateGoogleCalendarList(data: GoogleCalendarListApiResponse): GoogleCalendarList {
	return {
		...data,
		items: data.items ? data.items.map(hydrateGoogleCalendarListItem) : null,
	};
}